export const adminTabsEnum = {
    USERS: 'users',
    NCR_BIN: 'ncrBin',
};

export const adminTabsEnumIndexes = {
    [adminTabsEnum.USERS]: 0,
    [adminTabsEnum.NCR_BIN]: 1,
};
